import i18n_res from "./i18n_res.js";
import i18n_res_en from "./i18n_res_en.js";
import i18n_res_ua from "./i18n_res_ua.js";
import i18n_res_it from "./i18n_res_it.js";
import i18n_res_fr from "./i18n_res_fr.js";

const i18n = (res) => {
  const lang = localStorage.getItem('histomania_language');
  let retVal;
  switch(lang) {
    case "en": retVal = i18n_res_en[res]; break;
    case "ua": retVal = i18n_res_ua[res]; break;
    case "it": retVal = i18n_res_it[res]; break;
    case "fr": retVal = i18n_res_fr[res]; break;
    default: retVal = i18n_res[res];
  }
  if(!retVal) {
    retVal = i18n_res[res];
  }
  if(!retVal) {
    retVal = res;
  }
  return retVal;
}

export default i18n;
